import _ from 'underscore';
import { a11yProjection } from './a11y-projection';

export function a11yPlugin(definePlugin) {
  return definePlugin('a11y', ['config', 'gridView'], (config, gridView) => {
    const selectionConfig = gridView.get('selection') || config.selection;

    const { i18n } = _.result(config.plugins, 'a11y', {});

    const selectionA11yPatch = {
      selectAllLabel: i18n ? i18n.getString(_TL_('Select all')) : 'Select all',
      deselectAllLabel: i18n ? i18n.getString(_TL_('Deselect all')) : 'Deselect all',
      selectOneLabel: i18n ? i18n.getString(_TL_('Select this row')) : 'Select this row',
      deselectOneLabel: i18n ? i18n.getString(_TL_('Deselect this row')) : 'Deselect this row',
    };

    if (selectionConfig === true) {
      gridView.set({
        selection: {
          enabled: true,
          a11y: selectionA11yPatch,
        },
      });
    } else if ((_.isObject(selectionConfig) && selectionConfig.enabled !== false)) {
      gridView.set({
        selection: _.defaults({
          enabled: true,
          a11y: _.defaults( // Customized a11y config always win.
            {},
            selectionConfig.a11y,
            selectionA11yPatch
          ),
        }, selectionConfig),
      });
    }

    gridView.on('didUpdate', () => {
      // This is a workaround to get state from table view for a11y patching. DO NOT FOLLOW.
      // eslint-disable-next-line no-underscore-dangle
      const state = gridView._tableView && gridView._tableView._state;

      if (state) {
        const isSet = key => !_.isUndefined(state[key]);

        if (isSet('bodyRows')) {
          const $dataTable = gridView.$('.data-table[role="grid"], .table-container[role="grid"]');
          $dataTable.attr('aria-rowcount', state.bodyRows.length);
        }
      }
    });

    gridView.pipeStructureProjections(a11yProjection);
  });
}
